// src/App.jsx
import { useState } from 'react';
import { useAuth } from './hooks/useAuth';
import { useData } from './hooks/useData';
import AuthPage        from './pages/AuthPage';
import Dashboard       from './pages/Dashboard';
import Faturas         from './pages/Faturas';
import NovoLancamento  from './pages/NovoLancamento';
import Historico       from './pages/Historico';
import Cartoes         from './pages/Cartoes';
import Sidebar         from './components/Sidebar';
import './styles/global.css';

export default function App() {
  const { user, loading: authLoading, login, register, logout } = useAuth();
  const { cards, entries, loading: dataLoading, addCard, deleteCard, addNormal, addParcel, deleteEntry } = useData(user);
  const [page, setPage] = useState('dashboard');

  // Loading inicial
  if (authLoading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <div className="loading-text">Carregando...</div>
      </div>
    );
  }

  // Não autenticado → tela de login
  if (!user) {
    return <AuthPage onLogin={login} onRegister={register} />;
  }

  // Carregando dados do usuário
  if (dataLoading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <div className="loading-text">Buscando seus dados...</div>
      </div>
    );
  }

  const pages = {
    dashboard: <Dashboard  cards={cards} entries={entries} onNavigate={setPage} />,
    faturas:   <Faturas    cards={cards} entries={entries} />,
    novo:      <NovoLancamento cards={cards} addNormal={addNormal} addParcel={addParcel} onNavigate={setPage} />,
    historico: <Historico  cards={cards} entries={entries} onDeleteEntry={deleteEntry} />,
    cartoes:   <Cartoes    cards={cards} entries={entries} onAddCard={addCard} onDeleteCard={deleteCard} />,
  };

  return (
    <div className="app-layout">
      <Sidebar
        user={user}
        activePage={page}
        onNavigate={setPage}
        onLogout={logout}
      />
      {pages[page] || pages.dashboard}
    </div>
  );
}
